module.exports = "/_next/static/images/testimonial-image-min-63d555b7cdc1bdabbf8140ba714ba170.png.webp";